import { createContext, useContext, useState } from 'react'

interface Props {
  children: React.ReactNode
}

interface PanelDataContext<T> {
  data: T
  setData: (data: T) => void
}

const PanelDataProviderContext = createContext<PanelDataContext<unknown> | undefined>(undefined)

export const PanelDataProvider: React.FC<Props> = ({ children }) => {
  const [data, setData] = useState<unknown>({})

  return (
    <PanelDataProviderContext.Provider value={{ data, setData }}>
      {children}
    </PanelDataProviderContext.Provider>
  )
}

export const usePanelData = <T,>() => {
  const context = useContext(PanelDataProviderContext)
  if (context === undefined) {
    throw new Error('usePanel must be used within a PanelDataProvider')
  }
  return context as PanelDataContext<T>
}
